export enum CohortStatus {
  Pending = 0,
  PendingCommit = 1,
  Committed = 5,
  Completed = 10,
  Published = 100
}
